module.exports = __webpack_public_path__ + "static/img/14000662.ef46f929.png";